var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPinDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6,
    cy: 10.5,
    rx: 4.5,
    ry: 1.5,
    fill: "#0337A0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3.5C9.5 1.57 7.9295 0 6 0C4.0705 0 2.5 1.57 2.5 3.5C2.5 5.2595 3.807 6.716 5.5 6.96V10.5H6.5V6.96C8.193 6.716 9.5 5.2595 9.5 3.5Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinDark);
export default __webpack_public_path__ + "static/media/map-pin-dark.75ab667f.svg";
export { ForwardRef as ReactComponent };